import request from "../util/request";
import {APP_KEY,API_URL,WEB_CODE} from "../util/constants";

export function getActivityListRequest( callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);

    return fetch(API_URL+'/index.php/jzhuodong/index',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function getActivityDetailRequest(code, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("code", code);

    return fetch(API_URL+'/index.php/jzhuodong/info',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function getTianyuanListRequest(huodong_code,suyang_code,page, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("usertype", "1");
    formData.append("huodong", "1");
    formData.append("limit", '4');//全部
    formData.append("offset", page);
    formData.append("huodong_code", huodong_code);
    formData.append("suyang_code", suyang_code);
    formData.append("student_classcode", sessionStorage.getItem('classcode'));
    //formData.append("student_classcode", "2101");

    return fetch(API_URL+'/index.php/tianyuan/tianyuanlist',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function checkTianyuanRequest(tianyuan_id,check_status, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("tianyuan_id", tianyuan_id);
    formData.append("check_status", check_status);

    return fetch(API_URL+'/index.php/tianyuan/tianyuancheck',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function getDongtaiInfoRequest(tianyuanid, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("usertype", "1");
    formData.append("limit", '4');//全部
    formData.append("offset", '0');
    formData.append("tianyuanid", tianyuanid);

    return fetch(API_URL+'/index.php/tianyuan/tianyuaninfo',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function deleteDongtaiRequest(tianyuan_id, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("tianyuan_id", tianyuan_id);

    return fetch(API_URL+'/index.php/tianyuan/tianyuandel',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function sendCommentRequest(tianyuan_id,content, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("tianyuanid", tianyuan_id);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("usertype", '1');
    formData.append("content", content);

    return fetch(API_URL+'/index.php/tianyuan/huifuset',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function dianzanRequest(tianyuan_id, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("tianyuanid", tianyuan_id);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("usertype", '1');

    return fetch(API_URL+'/index.php/tianyuan/dianzan',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

export function addLiulanRequest(tianyuan_id, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("tianyuanid", tianyuan_id);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("usertype", '1');

    return fetch(API_URL+'/index.php/tianyuan/tianyuanpageview',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}

//获取教师发布的活动接口shenhe_status（0：待审核  1：审核通过  3：拒绝 ）
export function getActivityShenheListRequest(shenhe_status,js_huodong_code, callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);
    formData.append("userphone", sessionStorage.getItem('teacherphone'));
    formData.append("shenhe_status", shenhe_status);
    formData.append("js_huodong_code", js_huodong_code);

    return fetch(API_URL+'/index.php/tianyuan/jshuodonglist',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}
//获取活动类型接口
export function getActivityTypeListRequest( callback) {

    let formData = new FormData();
    formData.append("appkey", APP_KEY);

    return fetch(API_URL+'/index.php/tianyuan/jshuodongtype',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });

}
